export default __webpack_public_path__ + "static/HeroImage-209298549011e874a17798e4b040951e.jpg";